

export const toJsonText = (value) => {
  if (!value) return ''
  try {
    return JSON.stringify(JSON.parse(value), null, 2)
  } catch (e) {
    return value
  }
}

export const parseJsonText = (text) =>
  text && text.trim() ? JSON.parse(text) : null

export const jsonObjectRule = {
  validator: (_rule, text, callback) => {
    if (!text || !text.trim()) return callback()
    try {
      const value = JSON.parse(text)
      if (value === null || typeof value !== 'object' || Array.isArray(value)) {
        return callback('ต้องเป็น JSON object เช่น {"key": "value"}')
      }
      return callback()
    } catch (e) {
      return callback('JSON ไม่ถูกต้อง')
    }
  }
}
